/* eslint-disable react-refresh/only-export-components */
import { cn } from '@/components/ui';
import type {
  BeautifulMentionsTheme,
  BeautifulMentionsMenuProps,
  BeautifulMentionsMenuItemProps,
} from 'lexical-beautiful-mentions';
import { forwardRef } from 'react';

export const beautifulMentionsTheme: BeautifulMentionsTheme = {
  '@': 'p-1 bg-primary-100 rounded-[0.5rem] inline-block',
};

export function CustomMenu(params: BeautifulMentionsMenuProps) {
  // eslint-disable-next-line
  const { loading, ...props } = params;

  return (
    <ul
      style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
      }}
      className='text-popover-foreground absolute top-[2px] m-0 min-w-[8rem] overflow-hidden whitespace-nowrap rounded-medium border bg-default-0 bg-white p-2 shadow-md dark:bg-default-900'
      {...props}
    />
  );
}

export const CustomMenuItem = forwardRef<
  HTMLLIElement,
  BeautifulMentionsMenuItemProps
>(({ selected, ...props }, ref) => (
  <li
    ref={ref}
    className={cn(
      'relative flex cursor-pointer select-none items-center rounded-md px-2 py-1.5 text-sm outline-none',
      selected && 'bg-default-200 text-default-900 shadow-sm',
    )}
    {...props}
  />
));
CustomMenuItem.displayName = 'CustomMenuItem';

// const CustomMentionComponent = forwardRef<
//   HTMLDivElement,
//   BeautifulMentionComponentProps<MyData>
// >(({ trigger, value, data: myData, children, ...other }, ref) => {
//   return (
//     <div {...other} ref={ref} title={trigger + value}>
//       {value}
//     </div>
//   );
// });

// export class CustomMentionsNode extends BeautifulMentionNode {
//   constructor() {
//     super(triggerAsyncId, this.__value, dataFocusVisibleClasses, key)
//   }
//   static getType() {
//     return "custom-beautifulMention";
//   }
//   static clone(node: CustomBeautifulMentionNodeClass) {
//     // TODO: implement
//     return node;
//   }
//   static importJSON(serializedNode: SerializedBeautifulMentionNode) {
//     // TODO: implement
//   }
//   exportJSON(): SerializedBeautifulMentionNode {
//     // TODO: implement
//     return {
//       this.
//     }
//   }
//   component(): ElementType<BeautifulMentionComponentProps> | null {
//     // the component that renders the mention in the editor
//     // return null to use the default component
//     // 💡 if you only want to replace the component use the `createBeautifulMentionNode` helper method. See below for more details 👇
//   }
//   decorate(editor: LexicalEditor, config: EditorConfig): React.JSX.Element {
//     // TODO: implement
//   }
// }
